"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSlotsFromMetadata = getSlotsFromMetadata;
const slots = {
    // Skin
    "skin": { checker: (metadata) => !!metadata?.hytopia?.skins?.player },
    // Body
    "head": { checker: (metadata) => !!metadata?.hytopia?.models?.player?.head },
    "back": { checker: (metadata) => !!metadata?.hytopia?.models?.player?.back },
    "torso": { checker: (metadata) => !!metadata?.hytopia?.models?.player?.torso },
    // Arms
    "leftArm": { checker: (metadata) => !!metadata?.hytopia?.models?.player?.leftArm },
    "rightArm": { checker: (metadata) => !!metadata?.hytopia?.models?.player?.rightArm },
    // Hands
    "leftHand": { checker: (metadata) => !!metadata?.hytopia?.models?.player?.leftHand },
    "rightHand": { checker: (metadata) => !!metadata?.hytopia?.models?.player?.rightHand },
    // Items
    "leftItem": { checker: (metadata) => !!metadata?.hytopia?.models?.player?.leftItem },
    "rightItem": { checker: (metadata) => !!metadata?.hytopia?.models?.player?.rightItem },
    // Legs
    "leftLeg": { checker: (metadata) => !!metadata?.hytopia?.models?.player?.leftLeg },
    "rightLeg": { checker: (metadata) => !!metadata?.hytopia?.models?.player?.rightLeg },
    // Feet
    "leftFoot": { checker: (metadata) => !!metadata?.hytopia?.models?.player?.leftFoot },
    "rightFoot": { checker: (metadata) => !!metadata?.hytopia?.models?.player?.rightFoot },
};
function getSlotsFromMetadata(metadata) {
    const ret = [];
    for (const [slot, data] of Object.entries(slots)) {
        if (data.checker(metadata))
            ret.push(slot);
    }
    return ret;
}
//# sourceMappingURL=metadataUtils.js.map